import React, { FC, useEffect, useState } from 'react';
import { ExpandoFragment } from 'graphql/__generated__/types';
import { UitkExpandoListItem } from 'uitk-react-expando';
import SidebarExpandoTitle from './sidebar-expando-title';
import SidebarExpandoLinks from './sidebar-expando-links';
import useNavigationParams from '../../../hooks/useNavigationParams';
import { isActiveExpando } from '../../../utils/sidebar-navigation';
import { UitkBadgeSize } from 'uitk-react-badge';
import { UitkBadgeStandardTheme } from 'uitk-react-badge/dist/types';

interface SidebarExpandoProps {
  expando: ExpandoFragment;
  isActive: boolean;
}

const SidebarExpando: FC<SidebarExpandoProps> = ({ expando, isActive }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(isActive);
  const { currentPath } = useNavigationParams();

  useEffect(() => {
    if (isActiveExpando(expando.navigationElements, currentPath)) {
      setIsExpanded(true);
    }
  }, [currentPath]);

  const ExpandoTitle = (
    <SidebarExpandoTitle
      label={expando.label}
      isHighlighted={isActive}
      onClick={() => setIsExpanded((prevState) => !prevState)}
      badge={
        expando.badge
          ? {
              text: expando.badge.text,
              size: expando.badge.size as UitkBadgeSize,
              theme: expando.badge.theme as UitkBadgeStandardTheme,
            }
          : null
      }
    />
  );

  return (
    <UitkExpandoListItem
      expandoTitle={ExpandoTitle}
      expandoDescription={<SidebarExpandoLinks navigationLinks={expando.navigationElements} />}
      isVisible={isExpanded}
      onToggle={() => setIsExpanded((prevState) => !prevState)}
      triggerPosition="trailing"
    />
  );
};

export default SidebarExpando;
